import React from 'react';
import { useParams, useLocation, Navigate } from 'react-router-dom';

export function RedirectToNewPath() {
    const { webcommitId } = useParams();
    const location = useLocation();
    console.log("location in redirecttonew path is", location);

    // Construct the new path
    const newPath = `/service/SPO/commitDetails/${webcommitId}${location.search}`;

    console.log("Redirecting to:", newPath);

    return <Navigate to={newPath} replace />;
}
